
import { View } from 'backbone';
import { Model } from 'backbone';
import listService      from 'ListService.js';
import Template from 'behaviors/properties/main/set-field.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView.js';
import BasePropertyView from 'BasePropertyView.js';
import _ from 'lodash';
import namesUtil        from 'util/NamesUtil.js';
import widgetUtil       from 'util/WidgetUtil.js';
import Immutable        from 'immutable';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import constants from 'Constants.js';

//=====================================================================
//
// An instance of this view represents a field view behavior component.
//
// Rene Lopez, June 06, 2016
//
//=====================================================================

class MainSetFieldView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.title = 'Set Field Settings';
        this.mode = _.get(opts ,'config.mode') || '';
        this.type = this.model.get('factoryKey') === 'command_set_field_value' ? 'Field' : 'Target Field';
        this.factoryKey = _.get(opts, 'model.attributes.factoryKey') || '';
        this.fielIdProperty = 'fieldId';

        // PF-1920 -- was bad boolean expression
        if(this.mode === 'objects' || this.mode === 'lists'  || this.mode === 'objectsANDlists'){
            this.title = this.factoryKey === 'command_set_selection_items' ? 'Set Selection Settings' : 'Set Object Settings';
            this.type = 'Object';
            this.fielIdProperty = 'controlId';
        }

        this.events = {
            'click #valueOfAFieldButton'  : 'showValueFieldModal'
        };
        
        if(!this.model.get('valueOfAField')){
            this.model.set('valueOfAField','', {silent: true});
        }

        // if fieldIdProperty contains '$cur_' that is a concatenated ID (i.e. Table 1 - Text Input Column 2 - Current Row)
        // $all_ is for (Table 1 - Text Input Column 2 - All Rows)
        if (this.model.get(this.fielIdProperty)) {
            if ( !this.model.get('valueOfAField') || this.model.get('valueOfAField') === '' ){
                let fieldName = namesUtil.determineFieldName(this.model.get(this.fielIdProperty));
                this.model.set('valueOfAField', fieldName, {silent:true});
            }
        }

        this.listenTo(this.model, 'change', this.render);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';

        var sfModel = new Model();
        if(this.model.get("name") === 'Set Selection Items')
        {
            sfModel.set("dataSelectedItemId", this.model.get("controlId"), {silent:true});
        }
        else
        {
            sfModel.set("dataSelectedItemId", this.model.get("fieldId"), {silent:true});
        }
        var sfModal = new selectFieldModal({model: sfModel, mode:this.mode});
        sfModal.render().then((selectedField)=>{
            this.model.set(this.fielIdProperty, selectedField.id, {silent:true});

            const obj = listService.getObject(listService.cleanId(selectedField.id));
            let fieldName ='';

            const controlsWithItems = new Immutable.Set(['control_ranking', 
                                                         'control_drop_down', 
                                                         'control_list']);

            if( obj && controlsWithItems.contains(obj.model.get('factoryKey')) ){
                fieldName = selectedField.name;
            }else{
                fieldName = namesUtil.determineFieldName(selectedField.id);
            }


            // PF-2127 Changing the naming being placed for this control without the "- Caption"
            // Let me know if this syntax hits some functionality.
            if(this.model.get('factoryKey') === "command_set_selection_items"){
                this.model.set('valueOfAField', fieldName);
                this.model.set('widgetText', fieldName ) ;
            }
            else {
                this.model.set('valueOfAField', fieldName);
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model));
            }
        });
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    getViewValues(){
        return _.merge(this.model.toJSON(), {title:this.title, type:this.type});
    }



    render() {
        if(this.template) {
            this.$el.html(this.template(this.getViewValues()));
        }        
        this.delegateEvents();
        return this;
    }

}

export default MainSetFieldView;
